import { render, staticRenderFns } from "./OmTjenesten.vue?vue&type=template&id=8e2037d6"
import script from "./OmTjenesten.vue?vue&type=script&lang=js"
export * from "./OmTjenesten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports